/**
 * Google Analytics 4 (gtag.js).
 *
 * The measurement id comes from VUE_APP_GA_ID so local/dev builds stay out of
 * the production property - when it is empty every helper here is a no-op.
 *
 * This is a single page app, so gtag's own page_view is switched off
 * (send_page_view: false) and page views are sent from the router instead;
 * otherwise only the first load would ever be counted.
 */

const GA_ID = process.env.VUE_APP_GA_ID;

export const isAnalyticsEnabled = () => Boolean(GA_ID);

function gtag() {
  // Push arguments as-is: gtag reads `arguments`, not an array.
  window.dataLayer.push(arguments);
}

export function initAnalytics() {
  if (!isAnalyticsEnabled() || window.dataLayer) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = gtag;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  gtag('js', new Date());
  gtag('config', GA_ID, { send_page_view: false });
}

export function trackPageView(path, title) {
  if (!isAnalyticsEnabled() || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.origin + path,
    page_title: title || document.title,
  });
}

export function trackEvent(name, params = {}) {
  if (!isAnalyticsEnabled() || !window.gtag) return;
  window.gtag('event', name, params);
}
